import { ref, computed, watch } from '@vue/composition-api'
// import { title } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import router from '@/router'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList(props = nu) {
  const refListTable = ref(null)
  const toast = useToast()

  const tenantStorageProvider = ref([])

  store.dispatch('tenant/getAll')
  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems']);
  const tenantFilter = ref(null)

  if (router.currentRoute.params.id_tenant){
    tenantFilter.value = parseInt(router.currentRoute.params.id_tenant)
  }

  const nameTenant = ref(null)
  if (router.currentRoute.params.name_tenant){
    nameTenant.value = router.currentRoute.params.name_tenant
  }

  const tenantsStorageOptions = computed(() => store.getters['tenants_storage/getSelectedItems'])

  //store.dispatch('storage_provider/getAll')
  const storageProvider = ref([])//computed(() => store.getters['storage_provider/getSelectedItems']);
  const storageProviderFilter = ref('')

  const storageSpace = ref([
    { value: 'gb', label: 'GB'},
    { value: 'tb', label: 'TB'}
  ]);

  const assignedSpaceMinType = ref('mb')
  const assignedSpaceMaxType = ref('mb')
  const usedSpaceMinType = ref('mb')
  const usedSpaceMaxType = ref('mb')

  let sizeAssignedSpaceMin = 0;
  let sizeAssignedSpaceMax = 0;
  let sizeUsedSpaceMin = 0;
  let sizeUsedSpaceMax = 0;

  const assignedSpaceMin = ref('')
  const assignedSpaceMax = ref('')
  const usedSpaceMin = ref('')
  const usedSpaceMax = ref('')
  const sizeOptions = ref([
    { value: 'mb', label: 'MB'},
    { value: 'gb', label: 'GB'},
    { value: 'tb', label: 'TB'}
  ]);

  let tableColumns = [
    { label: 'tenants.store.id', key: 'id', sortable: true },
    { label: 'tenants.title', key: 'name_tenant', sortable: true },
    { label: 'tenants.store.storage_provider', key: 'storage_provider', sortable: true },
    { label: 'tenants.store.assigned_space', key: 'assigned_space', sortable: true },
    { label: 'tenants.store.used_space', key: 'used_space', sortable: true },
    { label: 'tenants.store.is_default', key: 'is_default', sortable: true },
    {
      label: 'date.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned',
    },
    {
      label: 'date.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned',
    },
  ]

  if (props.showFilters) {
    tableColumns = [{ label: 'actions.name', key: 'actions' }].concat(tableColumns);
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {

    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    let params =  {
      name: searchQuery.value,
      per_page: perPage.value,
      page: currentPage.value,
      order_by: sortBy.value,
      order_dir: isSortDirDesc.value,
      tenant_id: tenantFilter.value,
      assigned_space_min: sizeAssignedSpaceMin,
      assigned_space_max: sizeAssignedSpaceMax,
      used_space_min: sizeUsedSpaceMin,
      used_space_max: sizeUsedSpaceMax,
      storage_provider_id: storageProviderFilter.value
    }

    store.dispatch('tenant_storage_provider/getAll', params)
      .then(response => {
        tenantStorageProvider.value = response.data.map(item => ({
          ...item,
          name_tenant: nameTenant.value
        }))
        callback(tenantStorageProvider.value)
        totalList.value = response.total
      })
      .catch((e) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const formatDateAssigned = value => {
    const formattedDate = moment(value).format('DD/MM/YYYY HH:mm:ss')
    return formattedDate
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage,], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {

    if(assignedSpaceMinType.value == 'mb'){
      sizeAssignedSpaceMin = (assignedSpaceMin.value * 1048576)
    }
    if(assignedSpaceMaxType.value == 'mb'){
      sizeAssignedSpaceMax = (assignedSpaceMax.value * 1048576)
    }
    if(assignedSpaceMinType.value == 'gb'){
      sizeAssignedSpaceMin = (assignedSpaceMin.value * 1073741824)
    }
    if(assignedSpaceMaxType.value == 'gb'){
      sizeAssignedSpaceMax = (assignedSpaceMax.value * 1073741824)
    }
    if(assignedSpaceMinType.value == 'tb'){
      sizeAssignedSpaceMin = (assignedSpaceMin.value * 1099511627776)
    }
    if(assignedSpaceMaxType.value == 'tb'){
      sizeAssignedSpaceMax = (assignedSpaceMax.value * 1099511627776)
    }

    if(usedSpaceMinType.value == 'mb'){
      sizeUsedSpaceMin = (usedSpaceMin.value * 1048576)
    }
    if(usedSpaceMaxType.value == 'mb'){
      sizeUsedSpaceMax = (usedSpaceMax.value * 1048576)
    }
    if(usedSpaceMinType.value == 'gb'){
      sizeUsedSpaceMin = (usedSpaceMin.value * 1073741824)
    }
    if(usedSpaceMaxType.value == 'gb'){
      sizeUsedSpaceMax = (usedSpaceMax.value * 1073741824)
    }
    if(usedSpaceMinType.value == 'tb'){
      sizeUsedSpaceMin = (usedSpaceMin.value * 1099511627776)
    }
    if(usedSpaceMaxType.value == 'tb.'){
      sizeUsedSpaceMax = (usedSpaceMax.value * 1099511627776)
    }
    filters.value = {
      id_tenant: tenantFilter.value,
      assigned_space_min: sizeAssignedSpaceMin,
      assigned_space_max: sizeAssignedSpaceMax,
      used_space_min: sizeUsedSpaceMin,
      used_space_max: sizeUsedSpaceMax,
      storage_provider_id: storageProviderFilter.value
    };
    refetchData();
  }
  const clearSearchFilters = () => {
      tenantFilter.value = null
      assignedSpaceMin.value = null
      assignedSpaceMax.value = null
      usedSpaceMin.value = null
      usedSpaceMax.value = null
      storageProviderFilter.value = null
    buildFilters();
  }
  // ============================================

  return {
    storageProvider,
    storageSpace,
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    tenantOptions,
    tenantFilter,
    tenantsStorageOptions,
    storageProviderFilter,
    sizeOptions,
    assignedSpaceMinType,
    assignedSpaceMaxType,
    assignedSpaceMin,
    assignedSpaceMax,
    usedSpaceMinType,
    usedSpaceMaxType,
    usedSpaceMin,
    usedSpaceMax,
    refetchData,
    filtersCount,
    buildFilters,
    clearSearchFilters,
    tenantStorageProvider,
  }
}
